<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-5 pb-2 mb-3">
      <h2><span>Dashboard</span></h2>
      <!-- For future implementation, add back the below toolbar by removing the d-none class -->
      <div class="btn-toolbar mb-2 mb-md-0 d-none">
        <div class="btn-group mr-2">
          <button class="btn btn-sm btn-outline-secondary">Share</button>
          <button class="btn btn-sm btn-outline-secondary">Export</button>
        </div>
        <button class="btn btn-sm btn-outline-secondary dropdown-toggle">
          <span data-feather="calendar"></span>
          This week
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="text-center pt-5">
          <icon name="trending-up" class="feather-large"></icon>
          <h4>Coming soon</h4>
          <p>We'll be adding many new features soon.</p>
          <a class="btn btn-primary mt-5" href="mailto:partner-support@hokodo.co?subject=Roadmap" target="_blank">Find out more</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  mounted () {

  },
  components: {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Dashboard.vue